/* THE ILLUMINATEE - footer artwork wrapper.
   In 4.8 layout/theme.liquid wrapped the whole footer group in #illmn-footer-bg
   so the symbol pattern spanned all four footer sections as ONE continuous
   image. In 6.0 the wrapper is created here instead of in layout/theme.liquid,
   keeping the footer customization isolated from the theme core.

   Shopify tags every section in a group with .shopify-section-group-footer-group,
   so the footer sections are found reliably and moved, in order, into a single
   wrapper. The artwork itself is styled in assets/illmn-custom.css. */
(function () {
  'use strict';
  function wrapFooter() {
    if (document.getElementById('illmn-footer-bg')) return;
    var parts = document.querySelectorAll('.shopify-section-group-footer-group');
    if (!parts.length) return;
    var first = parts[0];
    if (!first.parentNode) return;
    var bg = document.createElement('div');
    bg.id = 'illmn-footer-bg';
    first.parentNode.insertBefore(bg, first);
    for (var i = 0; i < parts.length; i++) bg.appendChild(parts[i]);
  }
  if (document.readyState !== 'loading') wrapFooter();
  else document.addEventListener('DOMContentLoaded', wrapFooter);
})();
